import { render, staticRenderFns } from "./legal_new.vue?vue&type=template&id=4797f28f&scoped=true"
import script from "./legal_new.vue?vue&type=script&lang=js"
export * from "./legal_new.vue?vue&type=script&lang=js"
import style0 from "./legal_new.vue?vue&type=style&index=0&id=4797f28f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797f28f",
  null
  
)

export default component.exports